import type { ModuleIconComponent } from './moduleIconTypes'
import {
  AcademicCapIcon,
  AdjustmentsHorizontalIcon,
  AdjustmentsVerticalIcon,
  ArchiveBoxArrowDownIcon,
  ArchiveBoxIcon,
  ArchiveBoxXMarkIcon,
  ArrowDownTrayIcon,
  ArrowPathIcon,
  ArrowPathRoundedSquareIcon,
  ArrowTopRightOnSquareIcon,
  ArrowTrendingDownIcon,
  ArrowTrendingUpIcon,
  ArrowUpTrayIcon,
  ArrowsPointingInIcon,
  ArrowsPointingOutIcon,
  ArrowsRightLeftIcon,
  ArrowsUpDownIcon,
  AtSymbolIcon,
  BackwardIcon,
  BanknotesIcon,
  Bars2Icon,
  Bars3Icon,
  Bars4Icon,
  BarsArrowDownIcon,
  BarsArrowUpIcon,
  Battery0Icon,
  Battery100Icon,
  Battery50Icon,
  BeakerIcon,
  BellAlertIcon,
  BellIcon,
  BellSlashIcon,
  BellSnoozeIcon,
  BoltIcon,
  BoltSlashIcon,
  BookOpenIcon,
  BookmarkIcon,
  BookmarkSlashIcon,
  BookmarkSquareIcon,
  BriefcaseIcon,
  BugAntIcon,
  BuildingLibraryIcon,
  BuildingOffice2Icon,
  BuildingOfficeIcon,
  BuildingStorefrontIcon,
  CakeIcon,
  CalculatorIcon,
  CalendarDateRangeIcon,
  CalendarDaysIcon,
  CalendarIcon,
  CameraIcon,
  ChartBarIcon,
  ChartBarSquareIcon,
  ChartPieIcon,
  ChatBubbleBottomCenterIcon,
  ChatBubbleBottomCenterTextIcon,
  ChatBubbleLeftEllipsisIcon,
  ChatBubbleLeftIcon,
  ChatBubbleLeftRightIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  ChatBubbleOvalLeftIcon,
  CheckBadgeIcon,
  CheckCircleIcon,
  CheckIcon,
  CircleStackIcon,
  ClipboardDocumentCheckIcon,
  ClipboardDocumentIcon,
  ClipboardDocumentListIcon,
  ClipboardIcon,
  ClockIcon,
  CloudArrowDownIcon,
  CloudArrowUpIcon,
  CloudIcon,
  CodeBracketIcon,
  CodeBracketSquareIcon,
  Cog6ToothIcon,
  Cog8ToothIcon,
  CogIcon,
  CommandLineIcon,
  ComputerDesktopIcon,
  CpuChipIcon,
  CreditCardIcon,
  CubeIcon,
  CubeTransparentIcon,
  CurrencyDollarIcon,
  CurrencyEuroIcon,
  CurrencyPoundIcon,
  CursorArrowRaysIcon,
  CursorArrowRippleIcon,
  DevicePhoneMobileIcon,
  DeviceTabletIcon,
  DocumentArrowDownIcon,
  DocumentArrowUpIcon,
  DocumentChartBarIcon,
  DocumentCheckIcon,
  DocumentDuplicateIcon,
  DocumentIcon,
  DocumentMagnifyingGlassIcon,
  DocumentMinusIcon,
  DocumentPlusIcon,
  DocumentTextIcon,
  EllipsisHorizontalIcon,
  EllipsisVerticalIcon,
  EnvelopeIcon,
  EnvelopeOpenIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  EyeDropperIcon,
  EyeIcon,
  EyeSlashIcon,
  FaceFrownIcon,
  FaceSmileIcon,
  FilmIcon,
  FingerPrintIcon,
  FireIcon,
  FlagIcon,
  FolderArrowDownIcon,
  FolderIcon,
  FolderMinusIcon,
  FolderOpenIcon,
  FolderPlusIcon,
  ForwardIcon,
  FunnelIcon,
  GifIcon,
  GiftIcon,
  GiftTopIcon,
  GlobeAltIcon,
  GlobeAmericasIcon,
  GlobeAsiaAustraliaIcon,
  GlobeEuropeAfricaIcon,
  HandRaisedIcon,
  HandThumbDownIcon,
  HandThumbUpIcon,
  HashtagIcon,
  HeartIcon,
  HomeIcon,
  HomeModernIcon,
  IdentificationIcon,
  InboxArrowDownIcon,
  InboxIcon,
  InboxStackIcon,
  InformationCircleIcon,
  KeyIcon,
  LanguageIcon,
  LifebuoyIcon,
  LightBulbIcon,
  LinkIcon,
  LinkSlashIcon,
  ListBulletIcon,
  LockClosedIcon,
  LockOpenIcon,
  MagnifyingGlassCircleIcon,
  MagnifyingGlassIcon,
  MagnifyingGlassMinusIcon,
  MagnifyingGlassPlusIcon,
  MapIcon,
  MapPinIcon,
  MegaphoneIcon,
  MicrophoneIcon,
  MinusCircleIcon,
  MinusIcon,
  MoonIcon,
  MusicalNoteIcon,
  NewspaperIcon,
  NoSymbolIcon,
  NumberedListIcon,
  PaintBrushIcon,
  PaperAirplaneIcon,
  PaperClipIcon,
  PauseCircleIcon,
  PauseIcon,
  PencilIcon,
  PencilSquareIcon,
  PercentBadgeIcon,
  PhoneArrowDownLeftIcon,
  PhoneArrowUpRightIcon,
  PhoneIcon,
  PhoneXMarkIcon,
  PhotoIcon,
  PlayCircleIcon,
  PlayIcon,
  PlayPauseIcon,
  PlusCircleIcon,
  PlusIcon,
  PowerIcon,
  PresentationChartBarIcon,
  PresentationChartLineIcon,
  PrinterIcon,
  PuzzlePieceIcon,
  QrCodeIcon,
  QuestionMarkCircleIcon,
  QueueListIcon,
  RadioIcon,
  ReceiptPercentIcon,
  ReceiptRefundIcon,
  RectangleGroupIcon,
  RectangleStackIcon,
  RocketLaunchIcon,
  RssIcon,
  ScaleIcon,
  ScissorsIcon,
  ServerIcon,
  ServerStackIcon,
  ShareIcon,
  ShieldCheckIcon,
  ShieldExclamationIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
  SignalIcon,
  SignalSlashIcon,
  SparklesIcon,
  SpeakerWaveIcon,
  SpeakerXMarkIcon,
  Square2StackIcon,
  Square3Stack3DIcon,
  Squares2X2Icon,
  SquaresPlusIcon,
  StarIcon,
  StopCircleIcon,
  StopIcon,
  SunIcon,
  SwatchIcon,
  TableCellsIcon,
  TagIcon,
  TicketIcon,
  TrashIcon,
  TrophyIcon,
  TruckIcon,
  TvIcon,
  UserCircleIcon,
  UserGroupIcon,
  UserIcon,
  UserMinusIcon,
  UserPlusIcon,
  UsersIcon,
  VariableIcon,
  VideoCameraIcon,
  VideoCameraSlashIcon,
  ViewColumnsIcon,
  ViewfinderCircleIcon,
  WalletIcon,
  WifiIcon,
  WindowIcon,
  WrenchIcon,
  WrenchScrewdriverIcon,
  XCircleIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'

export type { ModuleIconComponent } from './moduleIconTypes'

/** Mapa nome (salvo no banco) → componente Heroicons outline. */
export const MODULE_HEROICON_MAP: Record<string, ModuleIconComponent> = {
  'academic-cap': AcademicCapIcon,
  'adjustments-horizontal': AdjustmentsHorizontalIcon,
  'adjustments-vertical': AdjustmentsVerticalIcon,
  'archive-box-arrow-down': ArchiveBoxArrowDownIcon,
  'archive-box': ArchiveBoxIcon,
  'archive-box-x-mark': ArchiveBoxXMarkIcon,
  'arrow-down-tray': ArrowDownTrayIcon,
  'arrow-path': ArrowPathIcon,
  'arrow-path-rounded-square': ArrowPathRoundedSquareIcon,
  'arrow-top-right-on-square': ArrowTopRightOnSquareIcon,
  'arrow-trending-down': ArrowTrendingDownIcon,
  'arrow-trending-up': ArrowTrendingUpIcon,
  'arrow-up-tray': ArrowUpTrayIcon,
  'arrows-pointing-in': ArrowsPointingInIcon,
  'arrows-pointing-out': ArrowsPointingOutIcon,
  'arrows-right-left': ArrowsRightLeftIcon,
  'arrows-up-down': ArrowsUpDownIcon,
  'at-symbol': AtSymbolIcon,
  'backward': BackwardIcon,
  'banknotes': BanknotesIcon,
  'bars-2': Bars2Icon,
  'bars-3': Bars3Icon,
  'bars-4': Bars4Icon,
  'bars-arrow-down': BarsArrowDownIcon,
  'bars-arrow-up': BarsArrowUpIcon,
  'battery-0': Battery0Icon,
  'battery-100': Battery100Icon,
  'battery-50': Battery50Icon,
  'beaker': BeakerIcon,
  'bell-alert': BellAlertIcon,
  'bell': BellIcon,
  'bell-slash': BellSlashIcon,
  'bell-snooze': BellSnoozeIcon,
  'bolt': BoltIcon,
  'bolt-slash': BoltSlashIcon,
  'book-open': BookOpenIcon,
  'bookmark': BookmarkIcon,
  'bookmark-slash': BookmarkSlashIcon,
  'bookmark-square': BookmarkSquareIcon,
  'briefcase': BriefcaseIcon,
  'bug-ant': BugAntIcon,
  'building-library': BuildingLibraryIcon,
  'building-office-2': BuildingOffice2Icon,
  'building-office': BuildingOfficeIcon,
  'building-storefront': BuildingStorefrontIcon,
  'cake': CakeIcon,
  'calculator': CalculatorIcon,
  'calendar-date-range': CalendarDateRangeIcon,
  'calendar-days': CalendarDaysIcon,
  'calendar': CalendarIcon,
  'camera': CameraIcon,
  'chart-bar': ChartBarIcon,
  'chart-bar-square': ChartBarSquareIcon,
  'chart-pie': ChartPieIcon,
  'chat-bubble-bottom-center': ChatBubbleBottomCenterIcon,
  'chat-bubble-bottom-center-text': ChatBubbleBottomCenterTextIcon,
  'chat-bubble-left-ellipsis': ChatBubbleLeftEllipsisIcon,
  'chat-bubble-left': ChatBubbleLeftIcon,
  'chat-bubble-left-right': ChatBubbleLeftRightIcon,
  'chat-bubble-oval-left-ellipsis': ChatBubbleOvalLeftEllipsisIcon,
  'chat-bubble-oval-left': ChatBubbleOvalLeftIcon,
  'check-badge': CheckBadgeIcon,
  'check-circle': CheckCircleIcon,
  'check': CheckIcon,
  'circle-stack': CircleStackIcon,
  'clipboard-document-check': ClipboardDocumentCheckIcon,
  'clipboard-document': ClipboardDocumentIcon,
  'clipboard-document-list': ClipboardDocumentListIcon,
  'clipboard': ClipboardIcon,
  'clock': ClockIcon,
  'cloud-arrow-down': CloudArrowDownIcon,
  'cloud-arrow-up': CloudArrowUpIcon,
  'cloud': CloudIcon,
  'code-bracket': CodeBracketIcon,
  'code-bracket-square': CodeBracketSquareIcon,
  'cog-6-tooth': Cog6ToothIcon,
  'cog-8-tooth': Cog8ToothIcon,
  'cog': CogIcon,
  'command-line': CommandLineIcon,
  'computer-desktop': ComputerDesktopIcon,
  'cpu-chip': CpuChipIcon,
  'credit-card': CreditCardIcon,
  'cube': CubeIcon,
  'cube-transparent': CubeTransparentIcon,
  'currency-dollar': CurrencyDollarIcon,
  'currency-euro': CurrencyEuroIcon,
  'currency-pound': CurrencyPoundIcon,
  'cursor-arrow-rays': CursorArrowRaysIcon,
  'cursor-arrow-ripple': CursorArrowRippleIcon,
  'device-phone-mobile': DevicePhoneMobileIcon,
  'device-tablet': DeviceTabletIcon,
  'document-arrow-down': DocumentArrowDownIcon,
  'document-arrow-up': DocumentArrowUpIcon,
  'document-chart-bar': DocumentChartBarIcon,
  'document-check': DocumentCheckIcon,
  'document-duplicate': DocumentDuplicateIcon,
  'document': DocumentIcon,
  'document-magnifying-glass': DocumentMagnifyingGlassIcon,
  'document-minus': DocumentMinusIcon,
  'document-plus': DocumentPlusIcon,
  'document-text': DocumentTextIcon,
  'ellipsis-horizontal': EllipsisHorizontalIcon,
  'ellipsis-vertical': EllipsisVerticalIcon,
  'envelope': EnvelopeIcon,
  'envelope-open': EnvelopeOpenIcon,
  'exclamation-circle': ExclamationCircleIcon,
  'exclamation-triangle': ExclamationTriangleIcon,
  'eye-dropper': EyeDropperIcon,
  'eye': EyeIcon,
  'eye-slash': EyeSlashIcon,
  'face-frown': FaceFrownIcon,
  'face-smile': FaceSmileIcon,
  'film': FilmIcon,
  'finger-print': FingerPrintIcon,
  'fire': FireIcon,
  'flag': FlagIcon,
  'folder-arrow-down': FolderArrowDownIcon,
  'folder': FolderIcon,
  'folder-minus': FolderMinusIcon,
  'folder-open': FolderOpenIcon,
  'folder-plus': FolderPlusIcon,
  'forward': ForwardIcon,
  'funnel': FunnelIcon,
  'gif': GifIcon,
  'gift': GiftIcon,
  'gift-top': GiftTopIcon,
  'globe-alt': GlobeAltIcon,
  'globe-americas': GlobeAmericasIcon,
  'globe-asia-australia': GlobeAsiaAustraliaIcon,
  'globe-europe-africa': GlobeEuropeAfricaIcon,
  'hand-raised': HandRaisedIcon,
  'hand-thumb-down': HandThumbDownIcon,
  'hand-thumb-up': HandThumbUpIcon,
  'hashtag': HashtagIcon,
  'heart': HeartIcon,
  'home': HomeIcon,
  'home-modern': HomeModernIcon,
  'identification': IdentificationIcon,
  'inbox-arrow-down': InboxArrowDownIcon,
  'inbox': InboxIcon,
  'inbox-stack': InboxStackIcon,
  'information-circle': InformationCircleIcon,
  'key': KeyIcon,
  'language': LanguageIcon,
  'lifebuoy': LifebuoyIcon,
  'light-bulb': LightBulbIcon,
  'link': LinkIcon,
  'link-slash': LinkSlashIcon,
  'list-bullet': ListBulletIcon,
  'lock-closed': LockClosedIcon,
  'lock-open': LockOpenIcon,
  'magnifying-glass-circle': MagnifyingGlassCircleIcon,
  'magnifying-glass': MagnifyingGlassIcon,
  'magnifying-glass-minus': MagnifyingGlassMinusIcon,
  'magnifying-glass-plus': MagnifyingGlassPlusIcon,
  'map': MapIcon,
  'map-pin': MapPinIcon,
  'megaphone': MegaphoneIcon,
  'microphone': MicrophoneIcon,
  'minus-circle': MinusCircleIcon,
  'minus': MinusIcon,
  'moon': MoonIcon,
  'musical-note': MusicalNoteIcon,
  'newspaper': NewspaperIcon,
  'no-symbol': NoSymbolIcon,
  'numbered-list': NumberedListIcon,
  'paint-brush': PaintBrushIcon,
  'paper-airplane': PaperAirplaneIcon,
  'paper-clip': PaperClipIcon,
  'pause-circle': PauseCircleIcon,
  'pause': PauseIcon,
  'pencil': PencilIcon,
  'pencil-square': PencilSquareIcon,
  'percent-badge': PercentBadgeIcon,
  'phone-arrow-down-left': PhoneArrowDownLeftIcon,
  'phone-arrow-up-right': PhoneArrowUpRightIcon,
  'phone': PhoneIcon,
  'phone-x-mark': PhoneXMarkIcon,
  'photo': PhotoIcon,
  'play-circle': PlayCircleIcon,
  'play': PlayIcon,
  'play-pause': PlayPauseIcon,
  'plus-circle': PlusCircleIcon,
  'plus': PlusIcon,
  'power': PowerIcon,
  'presentation-chart-bar': PresentationChartBarIcon,
  'presentation-chart-line': PresentationChartLineIcon,
  'printer': PrinterIcon,
  'puzzle-piece': PuzzlePieceIcon,
  'qr-code': QrCodeIcon,
  'question-mark-circle': QuestionMarkCircleIcon,
  'queue-list': QueueListIcon,
  'radio': RadioIcon,
  'receipt-percent': ReceiptPercentIcon,
  'receipt-refund': ReceiptRefundIcon,
  'rectangle-group': RectangleGroupIcon,
  'rectangle-stack': RectangleStackIcon,
  'rocket-launch': RocketLaunchIcon,
  'rss': RssIcon,
  'scale': ScaleIcon,
  'scissors': ScissorsIcon,
  'server': ServerIcon,
  'server-stack': ServerStackIcon,
  'share': ShareIcon,
  'shield-check': ShieldCheckIcon,
  'shield-exclamation': ShieldExclamationIcon,
  'shopping-bag': ShoppingBagIcon,
  'shopping-cart': ShoppingCartIcon,
  'signal': SignalIcon,
  'signal-slash': SignalSlashIcon,
  'sparkles': SparklesIcon,
  'speaker-wave': SpeakerWaveIcon,
  'speaker-x-mark': SpeakerXMarkIcon,
  'square-2-stack': Square2StackIcon,
  'square-3-stack-3d': Square3Stack3DIcon,
  'squares-2x2': Squares2X2Icon,
  'squares-plus': SquaresPlusIcon,
  'star': StarIcon,
  'stop-circle': StopCircleIcon,
  'stop': StopIcon,
  'sun': SunIcon,
  'swatch': SwatchIcon,
  'table-cells': TableCellsIcon,
  'tag': TagIcon,
  'ticket': TicketIcon,
  'trash': TrashIcon,
  'trophy': TrophyIcon,
  'truck': TruckIcon,
  'tv': TvIcon,
  'user-circle': UserCircleIcon,
  'user-group': UserGroupIcon,
  'user': UserIcon,
  'user-minus': UserMinusIcon,
  'user-plus': UserPlusIcon,
  'users': UsersIcon,
  'variable': VariableIcon,
  'video-camera': VideoCameraIcon,
  'video-camera-slash': VideoCameraSlashIcon,
  'view-columns': ViewColumnsIcon,
  'viewfinder-circle': ViewfinderCircleIcon,
  'wallet': WalletIcon,
  'wifi': WifiIcon,
  'window': WindowIcon,
  'wrench': WrenchIcon,
  'wrench-screwdriver': WrenchScrewdriverIcon,
  'x-circle': XCircleIcon,
  'x-mark': XMarkIcon,
}

/** Lista para o modal "Selecione um ícone". */
export const availableModuleIcons: Array<{ name: string; component: ModuleIconComponent }> =
  Object.entries(MODULE_HEROICON_MAP)
    .map(([name, component]) => ({ name, component }))
    .sort((a, b) => a.name.localeCompare(b.name))

export const resolveModuleHeroIcon = (name?: string): ModuleIconComponent | undefined => {
  if (!name) return undefined
  return MODULE_HEROICON_MAP[name.toLowerCase()]
}
